import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
// UI

import {
  Button,
  Flex,
  VStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

const OfferIdlePromptModal = ({ isOpened, idleTime, handleConfirmStillHere, remainingTime }) => {
  //remainingTime is in seconds

  const remainingMinutes = Math.floor(remainingTime / 60)
  const remainingSeconds = remainingTime % 60
  const idleTimeInMinutes = Math.floor(idleTime / (1000 * 60))

  const remainingTimeString = `${remainingMinutes} minute(s) and ${remainingSeconds} second${remainingSeconds !== 1 ? 's' : ''}`
  return (
    <Modal isOpen={isOpened} onClose={handleConfirmStillHere} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Idle Timeout</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" gap="2" justifyContent={'center'}>
            {/* Show warning if idle time > selected */}
            <Text>You have been idle for {idleTimeInMinutes} minutes.</Text>
            {/* Leaving offer in 1 minute if not clicked */}
            <Text>Leaving offer in {remainingTimeString}</Text>
            <Button colorScheme={'teal'} onClick={handleConfirmStillHere}>
              I am still here.
            </Button>
          </Flex>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default OfferIdlePromptModal
